import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.4rem;
  padding-block: ${sizes.xSmall};

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.gray2};
  }
`;

const IconWrapper = styled.div`
  padding-left: ${sizes.xSmall};
  padding-right: ${sizes.xSmall};
  transform: scale(1.4);
`;

const IconWithBackground = styled.div((props: { backgroundColor?: string }) => css`
  display: flex;
  border-radius: 100%;
  height: 3.6rem;
  width: 3.6rem;
  justify-content: center;
  align-items: center;

  ${props.backgroundColor && css`
    background: ${props.backgroundColor};
  `}
`);

const NotificationElement = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const DescriptionRow = styled.div`
  position: relative;
`;

const NotificationDescription = styled('div')<{ expanded?: boolean }>`
  font-size: ${fontSize.standard};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  ${(props) => !props.expanded && css`
    -webkit-line-clamp: 2;
  `}
`;

const ViewMoreButton = styled.button<{ collapsed?: boolean }>`
  background: none;
  border: none;
  color: ${colors.primary1};
  cursor: pointer;
  padding: 0;
  padding-left: 4px;
  font-size: ${fontSize.standard};
  font-weight: 600;
  white-space: nowrap;

  ${(props) => props.collapsed && css`
    position: absolute;
    bottom: 0;
    right: 0;
    background: white;
    padding-left: 4px;

    &::before {
      content: '...';
      color: inherit;
      font-weight: normal;
      padding-right: 2px;
    }
  `}

  &:hover {
    text-decoration: underline;
  }
`;

const TimePassedComponent = styled('div')`
  white-space: nowrap;
  align-self: baseline;
`;

export { Wrapper, IconWrapper, IconWithBackground, NotificationElement,
  DescriptionRow, NotificationDescription, TimePassedComponent, ViewMoreButton };

